module.exports = __webpack_public_path__ + "img/Palau.3ed3ecb7.svg";